import React from 'react'

export default function IGooglePlus( props ) {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" 
      xmlns="http://www.w3.org/2000/svg" {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M28 0C12.5347 0 0 12.537 0 28C0 43.463 12.5347 56 28 56C43.463 56 56 43.463 56 28C56 12.537 43.463 0 28 0ZM28.3267 44.3753C19.3013 44.3753 11.9933 37.0487 11.9933 28C11.9933 18.9513 19.3013 11.6247 28.3267 11.6247C32.7367 11.6247 36.4233 13.251 39.2513 15.8923L34.6453 20.5077V20.4983C32.9303 18.8603 30.7557 18.0203 28.3267 18.0203C22.9367 18.0203 18.557 22.5843 18.557 27.9907C18.557 33.3923 22.9367 37.9703 28.3267 37.9703C33.2173 37.9703 36.5447 35.1657 37.2307 31.3157H28.3267V24.9293H43.6917C43.897 26.026 44.0067 27.1693 44.0067 28.3687C44.0067 37.7253 37.7603 44.3753 28.3267 44.3753Z" fill="#FBFBFB"/>
    </svg>
  )
}